import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Prodotto} from "../../Progetti/Models/Prodotto";
import {Permission} from "../../Login/_guards/Permission";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {ListaProdottiCardComponent} from "../lista-prodotti-card/lista-prodotti-card.component";
import {ApiPathsService} from "../../api-paths.service";

@Component({
  selector: 'app-prodotti-correlati',
  templateUrl: './prodotti-correlati.component.html',
  styleUrls: ['./prodotti-correlati.component.css']
})
export class ProdottiCorrelatiComponent implements OnInit {
  @Input() items : Prodotto[] = [];
  @Output() itemsChange = new EventEmitter<Prodotto[]>();
  @Input() HasAddButton : boolean = true;
  @Input() HasDeleteButton : boolean = true;
  @Input() Editable : boolean = true;
@Input()Tipo: number;
  constructor(
    public permission: Permission,
    private modalService: NgbModal,
    public apiPaths: ApiPathsService,
  ) { }

  ngOnInit(): void {
  }

  Delete(prodotto: Prodotto) {
    if(!confirm('Sei sicuro di voler eliminare questo elemento dalla lista?')) return;
    var index = this.items.findIndex(x=> x == prodotto);
    if(index === -1)return;
    this.items.splice(index, 1);
  }

  Add() {
    let attmodal = this.modalService.open(ListaProdottiCardComponent, {
      centered: true,
      backdrop: 'static',
      size: 'xl',
    });
    (<ListaProdottiCardComponent>attmodal.componentInstance).Tipo = this.Tipo;
    (<ListaProdottiCardComponent>attmodal.componentInstance).AddClick.subscribe(data=> {
      this.items.push(data);
      attmodal.dismiss();
    });
  }
}
